import React from 'react';

import { Spin } from 'components';

import './PageLoader.styles.scss';

const PageLoader = () => {
  return (
    <div className="np-page-loader__overlay">
      <Spin size="large" />
    </div>
  );
};

export default PageLoader;
